import axios from "axios";
/**
 * Restaurant
 */
export const getRestaurant = (restaurant_id) => {
    return axios.get(`/chain/api/restaurant/${restaurant_id}`).then(res => res.data);
}
export const restaurantSaveDetails = (restaurant_id, data) => {
    return axios.post(`/chain/api/restaurant/${restaurant_id}/details`, { ...data }).then(res => res.data);
}

export const storeAdd = (data) => {
    return axios.post(`/chain/restaurants`, { ...data }).then(res => res.data);
}
export const restaurantSaveTimes = (restaurant_id, data) => {
    return axios.post(`/chain/api/restaurant/${restaurant_id}/times`, { ...data }).then(res => res.data);
}

export const restaurantSaveStoreAddons = (restaurant_id, data) => {
    return axios.post(`/chain/api/store/${restaurant_id}/settings/permits`, { ...data }).then(res => res.data);
}

export const integrationsLoad = (params) => {
    return axios.get(`/chain/api/integrations`, {params: params}).then(res => res.data);
}

export const integrationsSave = (data) => {
    return axios.post(`/chain/api/integrations`, { ...data }).then(res => res.data);
}

export const getIikoTransportOrganizations = (params) => {
    return axios.get(`/chain/api/integrations/iiko-transport/organizations`, {params: params}).then(res => res.data);
}

export const saveOrganization = (data) => {
    return axios.post(`/chain/api/integrations/iiko-transport/organization`, {...data}).then(res => res.data);
}

/**
 * servers
 * @param params
 * @returns {*}
 */
export const getIikoTransportServers = (params) => {
    return axios.get(`/chain/api/integrations/iiko-transport/servers`, {params: params}).then(res => res.data);
}


/**
 * Terminals
 */
export const getIikoTransportTerminals = (params) => {
    return axios.get(`/chain/api/integrations/iiko-transport/terminals`, {params: params}).then(res => res.data);
}
export const saveTerminal = (data) => {
    return axios.post(`/chain/api/integrations/iiko-transport/terminal`, {...data}).then(res => res.data);
}
/**
 * Payments
 */
export const getIikoTransportPayments = (params) => {
    return axios.get(`/chain/api/integrations/iiko-transport/payments`, {params: params}).then(res => res.data);
}
export const savePayment = (data) => {
    return axios.post(`/chain/api/integrations/iiko-transport/payment`, {...data}).then(res => res.data);
}
/**
 * tables
 */
export const importTables = (data) => {
    return axios.post(`/chain/api/integrations/iiko-transport/tables/import`, {...data}).then(res => res.data);
}
export const loadTables = (params) => {
    return axios.get(`/chain/api/integrations/iiko-transport/tables`, {params}).then(res => res.data);
}

/**
 * Discounts
 */
export const importDiscounts = (data) => {
    return axios.post(`/chain/api/integrations/iiko-transport/discounts/import`, {...data}).then(res => res.data);
}
export const loadDiscounts = (params) => {
    return axios.get(`/chain/api/integrations/iiko-transport/discounts`, {params}).then(res => res.data);
}
export const setServiceChargeId = (data) => {
    return axios.post(`/chain/api/integrations/iiko-transport/service-charge`, {...data}).then(res => res.data);
}

/**
 * ExternalMenus
 */
export const getIikoTransportExternalMenus = (params) => {
    return axios.get(`/chain/api/integrations/iiko-transport/external_menu`, {params: params}).then(res => res.data);
}
export const saveExternalMenu = (data) => {
    return axios.post(`/chain/api/integrations/iiko-transport/external_menu`, {...data}).then(res => res.data);
}

export const importFromPos = () => {
    return axios.post('/chain/api/menu/import-from-pos').then(res => res.data)
}
